import { Label as HuiLabel } from '@headlessui/react';
import { FC, ReactNode } from 'react';
import Markdown from 'react-markdown';
import { cx } from '@/utils/cx';

export type LabelProps = {
  children: ReactNode;
  className?: string;
  htmlFor?: string;
};

export const Label: FC<LabelProps> = ({ children, className }) => (
  <HuiLabel className={cx('min-h-6 text-sm/6 font-medium', className)}>
    {typeof children === 'string' ? <Markdown>{children}</Markdown> : children}
  </HuiLabel>
);
